import Liquidation from './liquidation.vue'

export default {
    path: 'liquidation',
    component: Liquidation
}
